import { ClemanClient } from '@forchange/cleman-client'
import { getTokenByServe } from '@/utils/token'
import { GetServerSidePropsContext } from 'next'
import { getOriginByServer } from '@/utils'

const basePath = '/api'

export enum ERROR_CODE {
  TOKEN_INVALID_ERROR = 'TOKEN_INVALID_ERROR', // token 无效
  ENTITY_NOTFOUND = 'ENTITY_NOT_FOUND', // fanbook用户未绑定
  FANBOOK_USER_BIND_EXISTS = 'FANBOOK_USER_BIND_EXISTS' // fanbook 重复绑定
}

export const getClemanClientByServer = (
  token: string = '',
  ctx: GetServerSidePropsContext
) => {
  const origin = getOriginByServer(ctx)

  const clemanClient = new ClemanClient({ baseURL: origin + basePath })

  if (token) {
    clemanClient.token = token
  } else {
    clemanClient.token = getTokenByServe(ctx)
  }

  return clemanClient
}

export const getClemanClientByClient = (token: string = '') => {
  const clemanClient = new ClemanClient()

  if (token) {
    clemanClient.token = token
  }

  return clemanClient
}
